// extracted by mini-css-extract-plugin
export default {"container":"ResponsiveSvg_container__6LmMn","svg":"ResponsiveSvg_svg__+5RvX","desktopSvg":"ResponsiveSvg_desktopSvg__7l9I8","mobileSvg":"ResponsiveSvg_mobileSvg__7wlD4"};